import styled, { css } from 'styled-components';
import {InlineLoader} from '@hiver/hiver-react-component-library'

const Button = css`
font-family: "Open Sans", sans-serif;
padding: 10px 19px;
font-size: 13px;
text-align:center;
border-radius: 4px;
border: none;
cursor: pointer;
`

export const StyledPrimaryButton = styled.button`
${Button}
color: white;
--btn-hue: 214;
--btn-saturation: 80%;
--btn-lightness: 49%;
--btn-alpha: 1;

${({disabled}) => {
    if(disabled){
        return 'cursor: not-allowed; --btn-lightness: 89%;'
    }
}}

&[data-color='red']{
    --btn-hue: 354;
    --btn-saturation: 60%;
    --btn-lightness: 51%;
}

background-color: hsla(var(--btn-hue), var(--btn-saturation), var(--btn-lightness), var(--btn-alpha));
&:hover{
    background-color: hsla(var(--btn-hue), var(--btn-saturation), calc( var(--btn-lightness) +  ${({disabled}) => disabled ? '0%' : '10%' }), var(--btn-alpha));
}

&[data-color="green"]{
    --btn-hue: 160;
    --btn-saturation: 57%;
    --btn-lightness: 64%;
    &:hover{
        --btn-saturation: 100%;
        --btn-lightness: 27%;
    }
}

`

export const StyledTransprentButton = styled.button`
${Button}
color: hsla(0, 0%, 51%, 1);
--btn-hue: 0;
--btn-saturation: 0;
--btn-lightness: 91%;
--btn-alpha: 1;

${({disabled}) => {
    if(disabled){
        return 'cursor: not-allowed;'
    }
}}

background-color: hsla(var(--btn-hue), var(--btn-saturation), var(--btn-lightness), var(--btn-alpha));

&:hover{
--btn-hue: 1;
--btn-saturation: 2%;
--btn-alpha: 1;
    background-color: hsla(var(--btn-hue), var(--btn-saturation), var(--btn-lightness), var(--btn-alpha));
}
`


export const StyledLoader = styled(InlineLoader)`
 & > div{
     background-color: white;
 }
`